// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  width: 100%;
  height: 100%;
  font-family: "Bosch Sans", sans-serif !important;
}

.content {
  font-family: "Bosch Sans", sans-serif !important;
}

.rootDiv {
  margin: 0 auto !important;
  background-color: white !important;
  font-family: "Bosch Sans", sans-serif !important;
}

body {
  font-family: "Bosch Sans", sans-serif !important;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/layouts.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;AACpB","sourcesContent":[".main {\n  width: 100%;\n  height: 100%;\n  font-family: \"Bosch Sans\", sans-serif !important;\n}\n\n.content {\n  font-family: \"Bosch Sans\", sans-serif !important;\n}\n\n.rootDiv {\n  margin: 0 auto !important;\n  background-color: white !important;\n  font-family: \"Bosch Sans\", sans-serif !important;\n}\n\nbody {\n  font-family: \"Bosch Sans\", sans-serif !important;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
